import { Box, Typography } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import OutlineButton from '../common/OutlineButton'
import { HOME_MOBILE_MQ } from './homeMobileLayout'
import { buttonHoverLightBorderedSx } from '../../theme/buttonHover'

export default function HomeEventRow({
  dayName,
  dayNumber,
  monthYear,
  title,
  description,
  image,
  to = '/events',
  isImageActive = false,
  onRowHover,
  dateBoxGap = '20px',
  dateNumberFontSize = { xs: 40, lg: 48 },
  dateLabelFontSize = { xs: 20, lg: 24 },
  mobileRowGap = '16px',
}) {
  const mobileDate = `${dayNumber} ${monthYear.replace(' ', ', ')}`

  return (
    <>
      <Box
        onMouseEnter={onRowHover}
        sx={{
          display: 'none',
          [HOME_MOBILE_MQ]: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: mobileRowGap,
            minHeight: 'auto',
            width: '100%',
            minWidth: 0,
          },
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0, width: '100%' }}>
          <Typography
            sx={{
              fontSize: 13,
              lineHeight: 'normal',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
              mb: '8px',
            }}
          >
            {mobileDate}
          </Typography>
          <Typography
            sx={{
              fontSize: 22,
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
              mb: '4px',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: 15,
              lineHeight: 1.2,
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
              display: '-webkit-box',
              WebkitLineClamp: 2,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}
          >
            {description}
          </Typography>
        </Box>
        <OutlineButton
          to={to}
          sx={{
            fontSize: 13,
            lineHeight: '13px',
            alignSelf: { xs: 'flex-start', sm: 'auto' },
            ...buttonHoverLightBorderedSx,
          }}
        >
          View Event
        </OutlineButton>
      </Box>

      <Box
        onMouseEnter={onRowHover}
        sx={{
          display: 'grid',
          [HOME_MOBILE_MQ]: { display: 'none' },
          gridTemplateColumns: {
            xs: '1fr',
            sm: 'auto 1fr',
            lg: 'auto minmax(0, 689px) 1fr auto auto',
          },
          gap: { xs: 3, lg: '40px' },
          alignItems: 'center',
          minHeight: { lg: 161 },
          width: '100%',
        }}
      >
        <Box
          sx={{
            border: '1px solid rgba(0,0,0,0.6)',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: dateBoxGap,
            p: '20px',
            flexShrink: 0,
            color: '#111',
            justifySelf: { xs: 'start', sm: 'start' },
            boxSizing: 'border-box',
          }}
        >
          <Typography sx={{ fontSize: dateLabelFontSize, lineHeight: 'normal', textAlign: 'center' }}>
            {dayName}
          </Typography>
          <Typography
            sx={{
              fontSize: dateNumberFontSize,
              lineHeight: 'normal',
              textAlign: 'center',
              fontWeight: 400,
            }}
          >
            {dayNumber}
          </Typography>
          <Typography
            sx={{
              fontSize: dateLabelFontSize,
              lineHeight: 'normal',
              textAlign: 'center',
              whiteSpace: 'nowrap',
            }}
          >
            {monthYear}
          </Typography>
        </Box>

        <Box
          component={RouterLink}
          to={to}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1px',
            minWidth: 0,
            gridColumn: { xs: '1', sm: '2', lg: '2' },
            textDecoration: 'none',
            color: 'inherit',
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 24, sm: 28, lg: 30 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: '#111',
            }}
          >
            {title}
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18, lg: 20 },
              lineHeight: 'normal',
              fontWeight: 400,
              color: 'rgba(17,17,17,0.6)',
            }}
          >
            {description}
          </Typography>
        </Box>

        {image && (
          <Box
            component={RouterLink}
            to={to}
            sx={{
              width: { xs: '100%', lg: 280 },
              height: { xs: 200, sm: 220, lg: 161 },
              overflow: 'hidden',
              borderRadius: '20px',
              flexShrink: 0,
              gridColumn: { xs: '1', sm: '1 / -1', lg: '4' },
              justifySelf: { xs: 'stretch', lg: 'end' },
              textDecoration: 'none',
              display: 'block',
            }}
          >
            <Box
              component="img"
              src={image}
              alt=""
              sx={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
                borderRadius: '20px',
                display: 'block',
                transition: 'transform 0.4s ease, opacity 0.4s ease',
                transform: {
                  xs: 'scale(1)',
                  lg: isImageActive ? 'scale(1)' : 'scale(0)',
                },
                opacity: {
                  xs: 1,
                  lg: isImageActive ? 1 : 0,
                },
              }}
            />
          </Box>
        )}

        <OutlineButton
          to={to}
          sx={{
            fontSize: 16,
            lineHeight: '17px',
            gridColumn: { xs: '1', sm: '1 / -1', lg: '5' },
            justifySelf: { sm: 'start', lg: 'end' },
            alignSelf: 'center',
            ...buttonHoverLightBorderedSx,
          }}
        >
          View This Event
        </OutlineButton>
      </Box>
    </>
  )
}
